export default __webpack_public_path__ + "static/media/deployment.62161ab8.svg";